import React from 'react';
import {
  ContentColors,
  Flex,
  HorizontalSpacing,
  IconCircleDeleteFilled,
  Input,
  NaviIconSearch,
  TextButton,
} from '@banhala/ui-kit';
import { useMarketDetail } from '../../../queries/useMarketDetail';
import { useAtom } from 'jotai/index';
import {
  marketGoodsCategoriesFilterAtom,
  marketGoodsListFilterAtom,
} from '../../../states/GoodsListFilter.atom';
import { useLogSearchKeyword } from '../hooks/useLogSearchKeyword';

export const InputKeywordSearch: React.FC<{
  marketId: number;
  focusable?: boolean;
  onPressCancel: () => void;
}> = props => {
  const { data: marketDetail } = useMarketDetail(props.marketId);
  const [value, setValue] = useAtom(marketGoodsListFilterAtom);
  const [categoriesFilter, setCategoriesFilter] = useAtom(
    marketGoodsCategoriesFilterAtom,
  );
  const [text, setText] = React.useState(value[props.marketId].keyword);
  const [focused, setFocused] = React.useState(false);

  const logSearchKeyword = useLogSearchKeyword();

  return (
    <Flex.Row padding={{ bottom: 12, left: 16 }}>
      <Flex.Row
        flex={1}
        backgroundColor={'gray20'}
        borderRadius={8}
        padding={{ left: 10 }}
        alignItems={'center'}
        height={36}
      >
        <NaviIconSearch
          width={20}
          height={20}
          fill={ContentColors.content_secondary}
        />
        <HorizontalSpacing size={4} />
        <Input
          style={{
            flex: 1,
          }}
          editable={props.focusable}
          // focusable={props.focusable}
          value={
            props.focusable ? text : categoriesFilter[props.marketId].keyword
          }
          onChangeText={text => {
            setText(text);
            setCategoriesFilter(prev => ({
              ...prev,
              [props.marketId]: {
                ...prev[props.marketId],
                keyword: text,
              },
            }));
          }}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          autoFocus={true}
          onSubmitEditing={({ nativeEvent }) => {
            setText(nativeEvent.text);
            setCategoriesFilter(prev => ({
              ...prev,
              [props.marketId]: {
                ...prev[props.marketId],
                keyword: nativeEvent.text,
              },
            }));
            setValue(prev => ({
              ...prev,
              [props.marketId]: {
                ...prev[props.marketId],
                keyword: nativeEvent.text,
              },
            }));
            logSearchKeyword(nativeEvent.text);
          }}
          fontVariant={'body2'}
          placeholder={`${marketDetail.market.name} 상품을 검색하세요`}
        ></Input>
        {focused && (
          <Flex
            width={40}
            height={36}
            alignItems={'center'}
            justifyContent={'center'}
            onPress={() =>
              setValue(prev => ({
                ...prev,
                [props.marketId]: { ...prev[props.marketId], keyword: '' },
              }))
            }
          >
            <IconCircleDeleteFilled
              width={20}
              height={20}
              fill={ContentColors.content_tertiary}
            />
          </Flex>
        )}
      </Flex.Row>
      <TextButton size={'medium'} color={'gray'} onPress={props.onPressCancel}>
        취소
      </TextButton>
    </Flex.Row>
  );
};
